import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CrmLayout from './CRM';
import './App.css';

const C = {
  bg: '#0f1117', purple: '#7c3aed', textDim: '#64748b',
};

const LoginScreen = () => (
  <div className="login-screen">
    <div className="login-card">
      <img src="/tsl-logo.png" alt="TSL Lighting" className="login-logo-img" />
      <h2 className="login-title">TSL Sales Hub</h2>
      <p className="login-sub">Sign in with your TSL Google account</p>
      <a href="/auth/google" className="login-btn">Sign in with Google</a>
    </div>
  </div>
);

const NoAccessScreen = ({ user, onLogout }) => (
  <div className="login-screen">
    <div className="login-card">
      <img src="/tsl-logo.png" alt="TSL Lighting" className="login-logo-img" />
      <h2 className="login-title">Access Required</h2>
      <p className="login-sub" style={{ marginBottom: 8 }}>
        Hi {user.name}, your account doesn't have access yet.
      </p>
      <p className="login-sub">
        Contact <span style={{ color: C.purple }}>it.support@tsllighting.com</span> for access.
      </p>
      <button onClick={onLogout} className="login-btn" style={{ marginTop: 16 }}>Sign Out</button>
    </div>
  </div>
);

const Loading = () => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', background: C.bg, color: C.textDim }}>
    <div className="spinner" />
    <p style={{ marginTop: 16, fontSize: 13 }}>Loading...</p>
  </div>
);

export default function App() {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    fetch('/auth/user')
      .then(res => { if (res.ok) return res.json(); throw new Error('Not authenticated'); })
      .then(u => { setUser(u); setAuthChecked(true); })
      .catch(() => setAuthChecked(true));
  }, []);

  if (!authChecked) return <Loading />;
  if (!user) return <LoginScreen />;
  if (user.role === 'none') return <NoAccessScreen user={user} onLogout={() => window.location.href = '/auth/logout'} />;

  return (
    <Routes>
      <Route path="/crm/*" element={<CrmLayout user={user} />} />
      <Route path="*" element={<Navigate to="/crm" replace />} />
    </Routes>
  );
}
